var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gr-border container"},[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-4 offset-4 mt-3"},[_c('p',[_c('router-link',{staticClass:"btn btn-yellow",attrs:{"to":"/"}},[_vm._v("Visit Homepage")])],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 text-center"},[_c('h2',{staticClass:"upper"},[_c('strong',[_vm._v("Access Denied")])])])
}]

export { render, staticRenderFns }